import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FormComponentBase } from '../../../core/component/forms/form-component.base';
import { ColumnDefinition, ColumnVisibility } from '../../../core/model/column-definition';
import { DataService } from '../../../core/service/base/data.service';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { FormCommandHandlerResolver } from '../../../core/service/command/form-command-handler-resolver.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { ImdImport } from '../../model/ImdImport';
import { MeterModelCommandHandlerResolver } from '../../service/command/meter-model-command-handler-resolver';
import { ImdImportService } from '../../service/imd-import.service';
import { MeterModelService } from '../../service/meter-type.service';

@Component({
    selector: 'app-import-model-form',
    templateUrl: './import-form.component.html',
    styleUrls: ['./import-form.component.scss'],
    providers: [DeleteFormCommandHandler, FormCommandHandlerResolver, { provide: DataService, useExisting: MeterModelService }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImdImportFormComponent extends FormComponentBase<ImdImport> {
  constructor(
    private _fb: FormBuilder,
    private _fc: FormControlExFactory,
    activatedRoute: ActivatedRoute,
    commandDispatcher: CommandDispatcher,
    handlerResolver: MeterModelCommandHandlerResolver,
    private _cdf: ColumnDefinitionFactory,
    private _service: ImdImportService,
    messageService: MessageService,
    navigation: NavigationService
  ) {
    super(activatedRoute, _service, messageService, navigation, commandDispatcher, handlerResolver);
    this.readingsColumns = [
      this._cdf.createDate('CONSUMPTION.CONSUMPTION_DATE', 'consumptionDate', ColumnVisibility.mandatory),
      this._cdf.create('CONSUMPTION.CONSUMPTION', 'consumption', ColumnVisibility.default),
      this._cdf.create('CONSUMPTION.MEDIA_TYPE.TYPE', 'meterTypeText', ColumnVisibility.default),
      this._cdf.create('COMMON.RENTAL_OBJECT', 'rentalId', ColumnVisibility.default),
      this._cdf.create('COMMON.LEASE_AGREEMENT_NUMBER', 'leaseAgreementNumber', ColumnVisibility.default),
      this._cdf.create('COMMON.INVOICED', 'debitOnLeaseAgreementActive', ColumnVisibility.default),
      this._cdf.create('CONSUMPTION.PRICELIST.PRICELIST', 'imdPriceListName', ColumnVisibility.optional),
      this._cdf.create('CONSUMPTION.METER.METER', 'meterName', ColumnVisibility.optional),
    ];
    this.addDeleteMenu = false;
  }

  protected createModel(): ImdImport {
    return new ImdImport();
  }

  readingsColumns: ColumnDefinition[];
  protected getFormGroup(): FormGroup {
    return this._fb.group({
      id: this._fc.createHidden(this.dataContext.id),
      importIdentifier: this._fc.createReadonly('CONSUMPTION.IMPORT.IMPORT_IDENTIFIER', this.dataContext.importIdentifier),
      recievedAt: this._fc.createReadonly('CONSUMPTION.IMPORT.RECIEVED_AT', this.dataContext.recievedAt),
      importedAt: this._fc.createReadonly('CONSUMPTION.IMPORT.IMPORTED_AT', this.dataContext.importedAt),
    });
  }
}
